

import React, { Component } from 'react';

import { BottomSheet } from 'react-spring-bottom-sheet'
import ScaleLoader from "react-spinners/ScaleLoader";
import {Elements} from '@stripe/react-stripe-js';
import {loadStripe} from '@stripe/stripe-js';
import StripePaymentComponent from './stripePaymentComponent'

const stateManager = require('../../../../../utils/state/stateManager');
const fatalErrorAction = require('../../../../../utils/state/actions/error/fatalErrorAction');
const apiProxy = require('../../../../../utils/api/apiProxy');
const paymentUtil = require('../../../../../utils/domain/paymentUtil');

class StripePaymentContainer extends Component 
{
    constructor(props)
    {
        super(props);

        this.state = {};
        this.state.stripeInitialized = false;
        this.state.clientSecret = "";
        this.state.stripeLoader = null; 
    }

    render()
    {
        if (!this.state.stripeInitialized)
        {
            this.initializeStripe();
            return <BottomSheet open={true} 
                            defaultSnap={({ maxHeight }) => Math.trunc(maxHeight * 0.30)}
                            snapPoints={({ minHeight, maxHeight }) => [Math.trunc(maxHeight * 0.30), Math.trunc(maxHeight * 0.30)]}
                            header="Please Wait">
                    
                    <div style={{marginTop:'20px'}}>
                        <div style={{textAlign:'center'}}>
                            <ScaleLoader
                                        height={50}
                                        width={6}
                                        color={"#808080"}
                                        loading={true}/>
                        </div>
                        <div style={{textAlign:'center'}}>
                            Initializing Payment
                        </div>
                    </div>

                </BottomSheet> 
        }

        const options = {
                            clientSecret: this.state.clientSecret,
                        };

                    
        let globalState = stateManager.getStore().getState();

        globalState.onCreditCardPaymentDismiss = this.props.onDismiss;
        globalState.onCreditCardPaymentCompletion = this.props.onCompletion;

        return <Elements stripe={this.state.stripeLoader} options={options}>
                    <StripePaymentComponent />
                </Elements> 
    }

    async initializeStripe()
    {
        try
        {
            await this.getServerToken();

            const publishableKey = stateManager.getStore().getState().onlinePaymentConfiguration.publishableKey;

            this.state.stripeLoader = await loadStripe(publishableKey);
            
            this.state.stripeInitialized = true;
            this.setState({});
        }
        catch(error)
        {
            stateManager.getStore().dispatch(fatalErrorAction.createAction(error));
        }
    }

    async getServerToken()
    {
        const amount = this.props.amount;
        const saleId = stateManager.getStore().getState().basket.order.id;
        const paymentIntent = paymentUtil.createPaymentIntent(amount, saleId);

        const onlinePaymentConfiguration = stateManager.getStore().getState().onlinePaymentConfiguration;

        const body = {};
        body.paymentProvider = onlinePaymentConfiguration.paymentProvider;
        body.paymentIntent = paymentIntent;

        const serverToken = await apiProxy.put("creditCardTokens", body)
        this.state.clientSecret = serverToken.client_secret;
    }
}

export default StripePaymentContainer;